import  { useEffect, useRef } from "react"; 
import { useParams, } from "react-router-dom"; 
import { AUTH_TOKEN, FIRM_PATH } from "../../constants/storageKeys"; 
import commonNetwork from "../../common/api/commonNetwork";
import { useRecoilState } from "recoil";
import { initialFirmInformation, tenantState } from "../../store/recoil/tenant/atoms";


type Props = {
    passtenantControl?: boolean,
    onTenantUpdate?: () => void
}
const TenantResolver = (props: Props) => {

    const { passtenantControl, onTenantUpdate } = props;  
    let { firmname } = useParams();
    const isFirmSelect = useRef(false); 
    const [firmTenantInformations, setFirmTenantInformations] = useRecoilState(tenantState);
    
    const getFirmName =()=>{

        if (firmname && firmname != "404" && firmname != "undefined" && firmname != ":firmname") {
            return firmname;
        }
        var pathName = window.location.pathname.replace("/","");
   
        if (pathName && firmname != "404") {
            return pathName;
        }
        return null;
    }
    const firmNameExtracted = getFirmName();

    
    if ((passtenantControl != true) && firmNameExtracted) {
        var prevFirm = localStorage.getItem(FIRM_PATH);
        if (prevFirm != firmNameExtracted) {
            localStorage.removeItem(AUTH_TOKEN)
        }
        localStorage.setItem(FIRM_PATH, firmNameExtracted || "");
    } 


    useEffect(() => {

        if (isFirmSelect.current == false && passtenantControl != true) {
            selectFirmInfo();
            isFirmSelect.current = true;
        }

    }, []); 


    const selectFirmInfo = async() => {

     
        if (firmNameExtracted) {
         
            let isError = false;
            let message = "";
            try { 
                const { data, errorMessage, isSuccess } = await commonNetwork.get("/tenant/"+firmNameExtracted);
                if (isSuccess ) {
                    setFirmTenantInformations({
                        firmInformations:data,
                        isfirmAvailable:true,
                        isError:false, 
                        isFetching:false,
                        errorMessage:"",
                        isSuccess:true
                    });

                    if (onTenantUpdate) {
                        onTenantUpdate();
                    }
                    
                  return data;
                } else {
                    isError = true;
                    message = errorMessage;
                }
              } catch (e:any) {
                isError = true;
                message = e;
              }

              if (isError) {
                setFirmTenantInformations({
                    firmInformations:initialFirmInformation,
                    isfirmAvailable:false,
                    isError:true, 
                    isFetching:false,
                    errorMessage:message,
                    isSuccess:false
                });
              }
        }

    }


    return (
        <div>

        </div>
    );
}

export default TenantResolver;